// Theme: digital-lavender
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'digital-lavender',
  name: 'DIGITAL LAVENDER',
  tagline: 'DIGITAL LAVENDER',
  description: 'Lavanda digital com base clean e contraste pastel.',
  category: 'neon-cyber',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#1B153A', '#281F50', '#A78BFA', '#EDE9FE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-digital-lavender'
  },
  colorVars: {
    '--accent': '#A78BFA',
    '--accent-foreground': '#1B153A',
    '--background': '#1B153A',
    '--border': '#5A4FB0',
    '--card': '#281F50',
    '--card-border-active': 'rgba(167, 139, 250, 0.35)',
    '--card-completed': '#231A48',
    '--card-foreground': '#EDE9FE',
    '--card-glow': 'rgba(167, 139, 250, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#EDE9FE',
    '--hold-fill': '#A78BFA',
    '--input': '#5A4FB0',
    '--modal-bg': '#1B153A',
    '--modal-border': '#5A4FB0',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#5A4FB0',
    '--muted-foreground': '#EDE9FE',
    '--nav-active': '#A78BFA',
    '--nav-bg': '#281F50',
    '--popover': '#281F50',
    '--popover-foreground': '#EDE9FE',
    '--primary': '#A78BFA',
    '--primary-foreground': '#1B153A',
    '--ring': '#A78BFA',
    '--secondary': '#5A4FB0',
    '--secondary-foreground': '#EDE9FE',
    '--streak': '#A78BFA',
    '--success': '#22c55e',
    '--success-foreground': '#1B153A',
    '--xp': '#A78BFA',
    '--xp-bg': '#281F50'
  },
  resolvedVars: {
    '--accent': '#A78BFA',
    '--accent-foreground': '#1B153A',
    '--accent-foreground-hsl': '250 47% 15%',
    '--accent-foreground-oklch': 'from #1B153A l c h',
    '--accent-hsl': '255 92% 76%',
    '--accent-oklch': 'from #A78BFA l c h',
    '--background': '#1B153A',
    '--background-hsl': '250 47% 15%',
    '--background-oklch': 'from #1B153A l c h',
    '--border': '#5A4FB0',
    '--border-hsl': '247 38% 50%',
    '--border-oklch': 'from #5A4FB0 l c h',
    '--border-w': '1px',
    '--card': '#281F50',
    '--card-border-active': 'rgba(167, 139, 250, 0.35)',
    '--card-completed': '#231A48',
    '--card-completed-hsl': '252 47% 19%',
    '--card-completed-oklch': 'from #231A48 l c h',
    '--card-foreground': '#EDE9FE',
    '--card-foreground-hsl': '251 91% 95%',
    '--card-foreground-oklch': 'from #EDE9FE l c h',
    '--card-glow': 'rgba(167, 139, 250, 0.08)',
    '--card-hsl': '251 44% 22%',
    '--card-oklch': 'from #281F50 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EDE9FE',
    '--foreground-hsl': '251 91% 95%',
    '--foreground-oklch': 'from #EDE9FE l c h',
    '--hold-fill': '#A78BFA',
    '--hold-fill-hsl': '255 92% 76%',
    '--hold-fill-oklch': 'from #A78BFA l c h',
    '--input': '#5A4FB0',
    '--input-hsl': '247 38% 50%',
    '--input-oklch': 'from #5A4FB0 l c h',
    '--modal-bg': '#1B153A',
    '--modal-bg-hsl': '250 47% 15%',
    '--modal-bg-oklch': 'from #1B153A l c h',
    '--modal-border': '#5A4FB0',
    '--modal-border-hsl': '247 38% 50%',
    '--modal-border-oklch': 'from #5A4FB0 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#5A4FB0',
    '--muted-foreground': '#EDE9FE',
    '--muted-foreground-hsl': '251 91% 95%',
    '--muted-foreground-oklch': 'from #EDE9FE l c h',
    '--muted-hsl': '247 38% 50%',
    '--muted-oklch': 'from #5A4FB0 l c h',
    '--nav-active': '#A78BFA',
    '--nav-active-hsl': '255 92% 76%',
    '--nav-active-oklch': 'from #A78BFA l c h',
    '--nav-bg': '#281F50',
    '--nav-bg-hsl': '251 44% 22%',
    '--nav-bg-oklch': 'from #281F50 l c h',
    '--popover': '#281F50',
    '--popover-foreground': '#EDE9FE',
    '--popover-foreground-hsl': '251 91% 95%',
    '--popover-foreground-oklch': 'from #EDE9FE l c h',
    '--popover-hsl': '251 44% 22%',
    '--popover-oklch': 'from #281F50 l c h',
    '--primary': '#A78BFA',
    '--primary-foreground': '#1B153A',
    '--primary-foreground-hsl': '250 47% 15%',
    '--primary-foreground-oklch': 'from #1B153A l c h',
    '--primary-hsl': '255 92% 76%',
    '--primary-oklch': 'from #A78BFA l c h',
    '--radius': '8px',
    '--ring': '#A78BFA',
    '--ring-hsl': '255 92% 76%',
    '--ring-oklch': 'from #A78BFA l c h',
    '--secondary': '#5A4FB0',
    '--secondary-foreground': '#EDE9FE',
    '--secondary-foreground-hsl': '251 91% 95%',
    '--secondary-foreground-oklch': 'from #EDE9FE l c h',
    '--secondary-hsl': '247 38% 50%',
    '--secondary-oklch': 'from #5A4FB0 l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#A78BFA',
    '--streak-hsl': '255 92% 76%',
    '--streak-oklch': 'from #A78BFA l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1B153A',
    '--success-foreground-hsl': '250 47% 15%',
    '--success-foreground-oklch': 'from #1B153A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(255 92% 76% / 0.15)',
    '--xp': '#A78BFA',
    '--xp-bg': '#281F50',
    '--xp-bg-hsl': '251 44% 22%',
    '--xp-bg-oklch': 'from #281F50 l c h',
    '--xp-hsl': '255 92% 76%',
    '--xp-oklch': 'from #A78BFA l c h'
  }
}
